import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getPermissions, getCompany, getSubcompany } from 'auth/selectors';
import * as Subaccounts from 'subaccounts/components';

class SubaccountsRowContainer extends Component {
  render = () => (
    <Subaccounts.Row
      handleToggle={this.props.handleToggle}
      subaccount={this.props.subaccount}
      company={this.props.company}
      subcompany={this.props.subcompany}
      permissions={this.props.permissions}
    />
  );
}

const mapStateToProps = (state) => ({
  permissions: getPermissions(state),
  company: getCompany(state),
  subcompany: getSubcompany(state),
});

export default connect(mapStateToProps, null)(SubaccountsRowContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/subaccounts/containers/SubaccountRowContainer.js